



















































































import {
  UserFeedbackEventType,
  UserFeedbackSatisfactionLevel
} from "@/shared/types";
import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { Validator } from "vee-validate";
import { mobileAppInfo } from "@/shared/mobileHelper";
import { useUserFeedbackStore } from "@/employee/store/userFeedback";
import { useThemeStore } from "@/shared/store/theme";
import theme from "@/shared/resource/theme";

@Component({
  computed: {
    theme () {
      return theme;
    }
  },
  components: {}
})
export default class FeedbackPrompt extends Vue {
  userFeedbackStore = useUserFeedbackStore();
  themeStore = useThemeStore();


  $validator: Validator;
  userRespondedYes = false;
  isSubmitting = true;
  userFeedbackModel = {
    satisfactionLevel: undefined,
    content: "",
    contactEmail: "",
    platform: mobileAppInfo().platform,
    application: mobileAppInfo().name,
    appVersion: mobileAppInfo().version
  };

  yes () {
    this.userRespondedYes = true;
  }

  no () {
    this.submitFeedbackEvent(UserFeedbackEventType.No);
  }

  maybeLater () {
    this.dismissedFeedbackEventPrompt();
  }

  dismissedFeedbackEventPrompt () {
    this.submitFeedbackEvent(UserFeedbackEventType.Dismiss);
  }

  dismissedFeedbackPrompt () {
    // user already responsed yes to the first prompt
    this.submitFeedbackEvent(UserFeedbackEventType.Yes);
  }

  submitFeedbackEvent (eventType: UserFeedbackEventType) {
    if (this.isSubmitting) {
      this.userFeedbackStore.saveFeedbackEvent({
        response: eventType
      });
    }
    this.isSubmitting = false;
    this.feedbackModalVisible = false;
  }

  submitFeedback () {
    this.$validator
        .validateAll()
        .then(result => {
          if (!result) {
            return;
          }

          this.userFeedbackStore.saveFeedbackEventWithResponse({
            response: UserFeedbackEventType.Yes,
            userFeedback: { ...this.userFeedbackModel }
          });
          this.isSubmitting = false;
          this.userRespondedYes = false;
        }).then(() => {
      if (this.userFeedbackStore.showAppRatePrompt) {
        setTimeout(() => {
              (window as any).Capacitor.Plugins.InAppReview.requestReview();
            },
            2000);
      }
    });
  }

  get feedbackModalVisible () {
    return this.userFeedbackStore.canShowPrompt;
  }

  set feedbackModalVisible (value: boolean) {
    this.userFeedbackStore.setShouldPrompt(value);
  }

  get satisfactionLevelOptions () {
    return [
      { value: UserFeedbackSatisfactionLevel.VerySatisfied, text: "Very Satisfied" },
      { value: UserFeedbackSatisfactionLevel.Satisfied, text: "Satisfied" },
      { value: UserFeedbackSatisfactionLevel.Neutral, text: "Neutral" },
      { value: UserFeedbackSatisfactionLevel.Dissatisfied, text: "Dissatisfied" },
      { value: UserFeedbackSatisfactionLevel.VeryDissatisfied, text: "Very Dissatisfied" }
    ];
  }
}
